export { BiografiaComponent } from  "./biografia/biografia.component";
export { ProcesoComponent } from  "./proceso/proceso.component";
export { OrganeriaComponent } from  "./organeria/organeria.component";
export { ObrasComponent } from  "./obras/obras.component";
export { ContactoComponent } from  "./contacto/contacto.component";
export { MainComponent } from  "./main/main.component";



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/components/index.paginas.ts